import { defineMessages, FormattedMessage } from 'react-intl';

import { commonMessages } from '@/messages/common';

const prefix = 'shoppingBagSummary';

export const Subtotal = <FormattedMessage {...commonMessages.subtotal} />;

export const ToPayLater = <FormattedMessage {...commonMessages.toPayLater} />;

export const ToPayNow = <FormattedMessage {...commonMessages.finalPayment} />;

export const DeliveryFee = <FormattedMessage {...commonMessages.deliveryFee} />;

export const Free = <FormattedMessage {...commonMessages.free} />;

export const Total = <FormattedMessage {...commonMessages.total} />;

export const Discount = <FormattedMessage {...commonMessages.promoApplied} />;

export const RetailDeliveryFees = (
  <FormattedMessage {...commonMessages.retailDeliveryFees} />
);

export const PayNowDeposit = (
  <FormattedMessage {...commonMessages.payNowDeposit} />
);

export const AlreadyPaidDeposit = (
  <FormattedMessage {...commonMessages.firstDepositPayment} />
);

export const AlreadyPaidAmount = (
  <FormattedMessage {...commonMessages.alreadyPaidDeposit} />
);
export const SalesTaxInfo = (
  <FormattedMessage
    defaultMessage='Sales tax calculated at checkout'
    id='checkout.shoppingBag.taxesNotice'
  />
);

export const VatIncludedMessage = (
  <FormattedMessage defaultMessage='Incl. Sales Tax' id='price.vat.included' />
);

export const ConsumptionIncludedMessage = (
  <FormattedMessage
    defaultMessage='Incl. Consumption Tax'
    id='price.consumption.included'
  />
);

export const ShippingAndTaxesNote = (
  <FormattedMessage
    defaultMessage='Free shipping to all US states, including Hawaii. All orders require a signature upon delivery.'
    id='checkout.shoppingBag.shippingNotice.us'
  />
);

export const PayWith = (
  <FormattedMessage defaultMessage='Pay with' id={`${prefix}.payWith`} />
);

export const AllTransactionsAreSafeAndSecure = (
  <FormattedMessage {...commonMessages.allTransactionsAreSafeAndSecure} />
);

export const SSLEncryptedPayment = (
  <FormattedMessage
    defaultMessage='128-bit SSL encrypted payment.{br}Breitling does not keep your payment details for your next orders.'
    id='checkout.shoppingBag.paymentNotice'
    values={{
      br: <br />,
    }}
  />
);

export const BreitlingDoesNotKeepYourPaymentDetailsForYourNextOrders = (
  <FormattedMessage
    defaultMessage='Breitling does not keep your payment details for your next orders'
    id={`${prefix}.breitlingDoesNotKeepYourPaymentDetailsForYourNextOrders`}
  />
);

export const YourShoppingBag = (
  <FormattedMessage
    defaultMessage='Your shopping bag'
    id='checkout.shoppingBag.yourShoppingBag'
  />
);

export const PreOrderNote = (
  <FormattedMessage
    defaultMessage='Pre-orders can take an average of two months to receive. We will let you know when your watch is ready to ship.'
    id={`${prefix}.preOrderNote`}
  />
);

export const messages = defineMessages({
  payWith0Finance: {
    id: `${prefix}.payWith0Finance`,
    defaultMessage: 'Pay with 0 finance',
  },
});
